import React from 'react';
import { NewTabLink } from '../components/new-tab-link';
import PageShell from '../components/page-shell';
import LogoStarsBlack from '../svg/logo-stars-black.svg';

const meta = {
  title: 'Page not found',
  description: 'Page not found.',
  pathname: '/404/'
};

export default class PageNotFound extends React.Component {
  render() {
    return (
      <PageShell meta={meta}>
        <div className="py60 flex-parent flex-parent--column">
          <div className="flex-child flex-child--grow align-center">
            <div className="mx-auto pb18" style={{ maxWidth: 150 }}>
              <LogoStarsBlack />
            </div>
            <h1 className="txt-h1-mm txt-h2 txt-fancy">404: Page not found</h1>
            <p className="txt-l mb12 mt12">
              Think this page should be here?{' '}
              <NewTabLink href="/contact/" className="link">
                Contact us.
              </NewTabLink>
            </p>
          </div>
        </div>
      </PageShell>
    );
  }
}

export { PageNotFound };
